import React from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "./../../../../../../store/userSlice";
import nodeinstance from "../../../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function UpdateDetailsPopup({
  token,
  list,
  PopUp,
  setPopUp,
  url,
  callBack,
  title,
}) {
  const dispatch = useDispatch();
  console.log("log to be printed in the console", list);
  const [expriyData, setExpriyData] = React.useState();
  const [issueData, setIssueData] = React.useState();
  const [addmissionData, setAddmissionData] = React.useState();
  const [medicalData, setmedicalData] = React.useState();
  const [govtData, setGovtData] = React.useState();
  const [inducementData, setInducementData] = React.useState();
  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await nodeinstance.post(
        url,
        {
          employee_id: list,
          issue_date: issueData,
          expiry_date: expriyData,
          admission_fee: addmissionData,
          medical_fee: medicalData,
          govt_fee: govtData,
          inducement_fee: inducementData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("res to be printed in the console", res);
      if (res.status == 200) {
        if (res.status === 200 && res.data.status === false) {
          dispatch(
            setAppError({
              msg: "Issue date cannot be greater then Application date",
              // color: "success",
            })
          );
          return;
        }
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setPopUp(false);
        callBack();
        // navigate(`/dashboard/fin-driving-licence/`);
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={(e) => submitHandler(e)}
            className="w-full place-items-center"
          >
            <div className="w-full place-items-center">
              <div className="w-full flex flex-col gap-3 my-3 p-2">
                <div className="form-control w-full place-items-center">
                  <h2 className="label place-items-center">{title}</h2>
                  <h2 className="label place-items-center">
                    <span className="label-text">ISSUE Date</span>
                  </h2>

                  <input
                    type="date"
                    onKeyDown={handleKeyDown}
                    id="field2"
                    className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                    required
                    onChange={(e) => setIssueData(e.target.value)}
                  />
                  <h2 className="label place-items-center">
                    <span className="label-text">Expiry Date</span>
                  </h2>

                  <input
                    type="date"
                    min={issueData}
                    onKeyDown={handleKeyDown}
                    id="field2"
                    className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                    required
                    onChange={(e) => setExpriyData(e.target.value)}
                  />
                  <h2 className="label place-items-center">
                    <span className="label-text">admission Fee</span>
                  </h2>

                  <input
                    type="number"
                    id="field2"
                    className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                    required
                    onChange={(e) => setAddmissionData(e.target.value)}
                  />
                  <h2 className="label place-items-center">
                    <span className="label-text">medical Fee</span>
                  </h2>

                  <input
                    type="number"
                    id="field2"
                    className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                    required
                    onChange={(e) => setmedicalData(e.target.value)}
                  />
                  <h2 className="label place-items-center">
                    <span className="label-text">GOVT. Fee</span>
                  </h2>

                  <input
                    type="number"
                    id="field2"
                    className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                    required
                    onChange={(e) => setGovtData(e.target.value)}
                  />
                  <h2 className="label place-items-center">
                    <span className="label-text">inducement Fee</span>
                  </h2>

                  <input
                    type="number"
                    id="field2"
                    className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                    required
                    onChange={(e) => setInducementData(e.target.value)}
                  />
                </div>

                <div
                  className="flex gap-3 w-full justify-center"
                  style={{ margin: 2 }}
                >
                  <button
                    className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                  >
                    <p>Submit</p>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
